import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster, type DefaultToastOptions } from 'react-hot-toast';
import { LucideProvider } from 'lucide-react';
import { Navbar, Footer, VerifyEmailBanner } from './components/layout';
import { AuthProvider } from './hooks';
import './index.css';

/*
 * react-hot-toast injects unlayered CSS (white background, fixed icon colours) that beats
 * Tailwind's layered utilities, so a `className` can't theme it. Inline styles from the
 * theme variables can, and they follow the theme with no extra logic.
 */
const TOAST_OPTIONS: DefaultToastOptions = {
  duration: 3000,
  style: {
    background: 'var(--color-base-100)',
    color: 'var(--color-base-content)',
    border: 'var(--border) solid var(--color-base-300)',
    borderRadius: 'var(--radius-box)',
    boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    fontSize: '0.875rem',
  },
  success: {
    iconTheme: { primary: 'var(--color-success)', secondary: 'var(--color-success-content)' },
  },
  error: {
    iconTheme: { primary: 'var(--color-error)', secondary: 'var(--color-error-content)' },
  },
};

export default function Layout() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <AuthProvider>
      {/* One stroke width for every icon in the app — see docs/brand.md › Iconography. */}
      <LucideProvider strokeWidth={1.75}>
        {mounted && (
          <Toaster
            position="bottom-right"
            toastOptions={TOAST_OPTIONS}
          />
        )}
        <div className="min-h-screen flex flex-col safe-bottom">
          <div className="bg-base-100 border-b border-base-300 safe-top sticky top-0 z-50">
            <Navbar />
            <VerifyEmailBanner />
          </div>
          <main className="flex-1 flex flex-col">
            <Outlet />
          </main>
          <Footer />
        </div>
      </LucideProvider>
    </AuthProvider>
  );
}
